// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/chunks/" + (chunkId === 3104 ? "3975359d" : chunkId) + "." + {"1237":"d60acaa50bb68c06","2242":"56d98f457dd24128","3104":"efa99665f0ae92ae"}[chunkId] + ".js";
};